import { makeStyles } from '@material-ui/core/styles';

const getClusterMarkerWidth = (pointCount) => {
  if (pointCount < 10) return 30;
  if (pointCount < 25) return 40;
  if (pointCount < 50) return 60;
  if (pointCount < 80) return 80;
  if (pointCount < 120) return 100;
  if (pointCount < 150) return 130;
  return 200;
};

const getClusterMarkerBackgroundColor = (pointCount) => {
  if (pointCount < 10) return '#e70d70';
  if (pointCount < 25) return '#d51884';
  if (pointCount < 50) return '#c32397';
  if (pointCount < 80) return '#b12eab';
  if (pointCount < 120) return '#a038be';
  if (pointCount < 150) return '#8e43d1';
  return '#7C4EE5';
};

const useStyles = makeStyles(() => ({
  root: ({ pointCount }) => ({
    width: `${getClusterMarkerWidth(pointCount)}px`,
    height: `${getClusterMarkerWidth(pointCount)}px`,
    borderRadius: `${getClusterMarkerWidth(pointCount) / 2}px`,
    background: getClusterMarkerBackgroundColor(pointCount),
    opacity: '0.5',
    transform: 'translate(-50%, -50%)',
  }),
  text: {
    width: '100%',
    height: '100%',
    color: 'white',
    fontSize: '20px',
    fontWeight: 600,
    position: 'absolute',
    textAlign: 'center',
    marginTop: 'calc(50% - 0.7rem)',
  },
}));

export default useStyles;
